import { DEFAULT_APP_LANGUAGE } from "./constants"

export const resolveToSupportedLanguage = (
	languageCode: string,
	supportedLanguages: string[] | readonly string[],
): string | undefined => {
	return (
		supportedLanguages.find(
			l =>
				getLanguageFromLocale(l) ===
				getLanguageFromLocale(languageCode),
		) ?? DEFAULT_APP_LANGUAGE
	)
}

export const getLanguageFromLocale = (locale: string) => {
	const language = locale.split("-")[0]
	return language
}

export const getCountryCodeFromLocale = (locale: string) => {
	const countryCode = locale.split("-")[1]
	return countryCode
}
